/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-central-1",
    "aws_appsync_graphqlEndpoint": "https://5rvopk4thfgyrj7g3fgjdyzarm.appsync-api.eu-central-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-central-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-lah7xntpw5emrih6u3cvntqabu",
    "aws_cloud_logic_custom": [
        {
            "name": "api42e141d2",
            "endpoint": "https://fkzjotsg45.execute-api.eu-central-1.amazonaws.com/production",
            "region": "eu-central-1"
        },
        {
            "name": "emailing",
            "endpoint": "https://lp0out5lr3.execute-api.eu-central-1.amazonaws.com/production",
            "region": "eu-central-1"
        }
    ],
    "aws_cognito_identity_pool_id": "eu-central-1:ac5efc61-42cf-4049-9267-9a3383d820bb",
    "aws_cognito_region": "eu-central-1",
    "aws_user_pools_id": "eu-central-1_ahxb6Hr6G",
    "aws_user_pools_web_client_id": "6drsheued2gu07qaac9l83sfq3",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "specificationsbucket180450-production",
    "aws_user_files_s3_bucket_region": "eu-central-1"
};


export default awsmobile;
